import React from 'react';
import { Body5, Container } from '@ui';
import { FormattedJson } from './FormattedJson';

export const AgentQAPairList = ({ items, isStreaming = false }) => {
  if (!items || items.length === 0) return null;

  return (
    <Container>
      {items.map((item, index) => (
        <Container key={index}>
          <Body5>{item.question}</Body5>
          <Container top={8}>
            {item.response == null ? (
              <Body5 isLowContrast>{isStreaming ? 'Working on an answer...' : ''}</Body5>
            ) : (
              <FormattedJson value={item.response} />
            )}
          </Container>
        </Container>
      ))}
    </Container>
  );
};
